import React from 'react';
import {Field} from 'redux-form';
import MaskedInput from 'react-text-mask';
import TextField from "housecall-ui/dist/DesignSystem/Inputs/TextFields/TextField"
import { isPresent } from 'utils/isPresent';

const TextMaskCustom = ({inputRef, ...rest}) => {
  return (<MaskedInput
    {...rest}
    placeholderChar={'\u2000'}
    showMask={false}
  />)
}

const NumberFormattedFormTextField = (props) => (
    <Field component={renderFormattedField}
           {...props}/>
)

const renderFormattedField = ({input, placeholder, helperText, mask, meta: {touched, error}, endAdornment, disableUnderline = false, onBlur, ...custom}) => {
    return (
        <TextField
            fullWidth
            error={touched && isPresent(error)}
            helperText={touched && (typeof error == "string" && error.length > 0) ? error : (helperText || '')}
            variant='filled'
            InputProps={{
                inputComponent: TextMaskCustom,
                endAdornment: endAdornment,
                disableUnderline: disableUnderline,
                onBlur: onBlur
            }}
            inputProps={{
                mask: mask,
                placeholder: placeholder,
                ...input
            }}
            InputLabelProps={{
                shrink: !!input.value
            }}
            {...input}
            {...custom}
        />
    );
}

export default NumberFormattedFormTextField
